export const getPercentFromNumbers = (a: number, b: number) => (a * 100) / b;
export const getPercentFromNumber = (a: number, percent: number) =>
    (a / 100) * percent;
